import KeenSlider from "keen-slider";
import "keen-slider/keen-slider.min.css";

// 第二校舎ページ用のスライダー
export class SecondCampusSlider {
  constructor() {
    const el = document.getElementById("js-second-campus-slider");
    if (!el) return;

    const animation = (slideLength) => ({
      duration: slideLength * 5000,
      easing: (t) => t,
    });

    new KeenSlider(el, {
      loop: true,
      renderMode: "precision",
      mode: "free",
      drag: false,
      slides: {
        perView: 3.65,
        spacing: 36,
      },
      breakpoints: {
        "(max-width: 750px)": {
          slides: {
            perView: 2.5,
            spacing: 18,
          },
        },
      },
      created(s) {
        s.moveToIdx(s.slides.length - 1, true, animation(s.slides.length - 1));
      },
      updated(s) {
        s.moveToIdx(s.track.details.abs + s.slides.length - 1, true, animation(s.slides.length - 1));
      },
      animationEnded(s) {
        s.moveToIdx(s.track.details.abs + s.slides.length - 1, true, animation(s.slides.length - 1));
      },
    });
  }
}